import React, { useState } from "react";
import {
  Table,
  Tag,
  Button,
  Row,
  Select,
  Card,
  Typography,
  DatePicker,
} from "antd";
import { useQuery } from "@apollo/client";
import type { ColumnsType } from "antd/es/table";
import { GET_ORDERS, GET_CLIENTS, GET_LOCATIONS } from "./requests";
import LoadingSpinner from "../../components/loading";
import { orderStatus } from "../../utils/constants";
import moment from "moment-timezone";
import { Container } from "./elements";
import ViewDetailModal from "./viewDetail";
import ProductList from "../../components/productsList";

const { Text } = Typography;
const { RangePicker } = DatePicker;



const Abandoned: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(false);
  const [dateRange, setDateRange] = useState(null);

  const [clientSearch, setClientSearch] = useState("");
  const [selectedClient, setSelectedClient] = useState(null);

  const [locationSearch, setLocationSearch] = useState("");
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [pageConfig, setPageConfig] = useState({
    page: 1,
    pageSize: 10,
  });

  const { loading, error, data } = useQuery(GET_ORDERS, {
    variables: {
      params: pageConfig,
      status: { eq: orderStatus.created.value },
      client: { eq: selectedClient },
      location: { eq: selectedLocation },
      excludeStatus: { nin: [] },
    },
  });

  const { data: clientsData } = useQuery(GET_CLIENTS, {
    variables: {
      params: { page: 1,
        pageSize: 5 },
      search: clientSearch,
    },
  });

  const { data: locationsData } = useQuery(GET_LOCATIONS, {
    variables: {
      params: { page: 1,
        pageSize: 5 },
      name: locationSearch,
    },
  });

  const filteredOptions = clientsData?.clients?.results.map((client: any) => ({
    label: `${client.user?.firstName} ${client.user?.lastName}`,
    value: client.id,
  }));

  const filteredLocationsOptions = locationsData?.locations?.results.map((location: any) => ({
    label: `${location.name}`,
    value: location.id,
  }));

  if (error) return <div>Error: {error.message}</div>;

  const columns: ColumnsType<any> = [
    {
      title: "Cliente",
      key: "client",
      render: (record) => (
        <div>
          <Text style={{ fontWeight: "700" }}>
            {record.client?.user?.firstName} {record?.client?.user.lastName}
          </Text>
          <br />
          <Text style={{ color: "grey" }}>{record?.reference}</Text>
        </div>
      ),
    },
    {
      title: "Estatus",
      key: "status",
      render: (record) => (
        <>
          <Tag color={orderStatus[record.status].color}>
            {orderStatus[record.status].name}
          </Tag>
          <br />
          <Text style={{ color: "grey" }}>
            {record.status == "complete"
              ? moment(record.updatedAt).format("lll")
              : "Sin completar"}
          </Text>
        </>
      ),
    },

    {
      title: "Productos",
      key: "products",
      dataIndex: "lineItems",
      render: (lineItems: any[]) => {
        const products =
          lineItems?.map((item) => ({
            product: {
              _id: item.product.id,
              img: item.product.img,
              title: item.product.title,
              description: item.product.description,
              product: {
                name: item.product.product.name,
                description: item.product.product.description,
              },
            },
          })) ?? [];

        if (products.length > 0) {
          return (
            <div
              style={{ maxHeight: "200px",
                overflowY: "auto",
                width: "100%" }}
            >
              <ProductList lineItems={products} />
            </div>
          );
        } else {
          return <Tag color="yellow">Sin Productos</Tag>;
        }
      },
    },
    {
      title: "Total",
      key: "total",
      render: (record) => (
        <>
          <Tag
            color="green"
            style={{ fontSize: 16,
              padding: 5,
              fontWeight: "800" }}
          >
            ${record.price.toLocaleString()}{" "}
            <Text style={{ fontSize: 8,
              color: "green" }}>MXN</Text>
          </Tag>
        </>
      ),
    },
    {
      title: "Franquicia",
      key: "location",
      render: (record) => (
        <Text style={{ color: "green",
          fontSize: 16,
          fontWeight: "700" }}>{record.location.name}</Text>
      ),
    },
    {
      title: "Acciones",
      key: "actions",
      render: (row) => (
        <>
          <Button
            onClick={() => {
              setVisible(true);
              setSelectedOrder(row);
            }}
            type="primary"
          >
            Ver Detalle
          </Button>
        </>
      ),
    },
  ];

  return (
    <Container style={{ padding: "20px",
      overflow: "scroll",
      height: "90vh" }}>
      <Card
        style={{
          width: "100%",
          borderRadius: 10,
          overflow: "hidden",
          boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px",
        }}
        bodyStyle={{ padding: 0 }}
      >
        <Row style={{ padding: 20 }}>
          <div>
            <Text style={{ fontWeight: "700",
              fontSize: 18 }}>
              Rango de Fechas
            </Text>
            <br />{" "}
            <RangePicker
              style={{ width: "200px" }}
              showTime
              onChange={(e) => setDateRange(e)}
              value={dateRange}
              disabled
              placeholder={["Comienzo", "Fin"]}
            />
          </div>
          <div style={{ marginLeft: 10 }}>
            <Text style={{ fontWeight: "700",
              fontSize: 18 }}>
              Filtrar Cliente
            </Text>
            <br />
            <Select
              showSearch
              style={{ width: "200px" }}
              placeholder="Cliente"
              onSearch={(value) => setClientSearch(value)}
              onChange={(value) => setClientSearch(value)}
              onSelect={(value) => setSelectedClient(value)}
              onClear={() => setSelectedClient(null)}
              allowClear
              options={filteredOptions}
              filterOption={false}
            />
          </div>
          <div style={{ marginLeft: 10 }}>
            <Text style={{ fontWeight: "700",
              fontSize: 18 }}>
              Filtrar Franquicia
            </Text>
            <br />

            <Select
              showSearch
              allowClear
              style={{ width: "200px" }}
              placeholder="Franquicia"
              onSearch={(value) => setLocationSearch(value)}
              onSelect={(value) => setSelectedLocation(value)}
              onClear={() => { setSelectedLocation(null); setLocationSearch(""); }}
              value={selectedLocation}
              options={filteredLocationsOptions}
              filterOption={false}
            />
          </div>
        </Row>
        {loading ? (
          <LoadingSpinner />
        ) : (
          <>
            <div style={{ marginTop: 10 }}>
              <Table
                dataSource={data?.orders?.results || []}
                columns={columns}
                rowKey="id"
                pagination={{
                  current: Number(pageConfig.page),
                  defaultCurrent: pageConfig.page,
                  pageSize: Number(pageConfig.pageSize),
                  defaultPageSize: pageConfig.pageSize,
                  total: data?.orders?.info?.count,
                  showTotal: (total) => <Text disabled>{`${total} resultados`}</Text>,
                  onChange: (page, pageSize) => {
                    setPageConfig({
                      page,
                      pageSize,
                    });
                  },
                  showSizeChanger: true,
                }}
              />
              <ViewDetailModal
                visible={visible}
                setVisible={setVisible}
                selectedOrder={selectedOrder}
              />
            </div>
          </>
        )}
      </Card>
    </Container>
  );
};

export default Abandoned;
